import API from './base';

class UserAPI extends API {
  signIn(payload) {
    return this.post('/api/web/v1/student_sessions', payload);
  }

  signUp(payload) {
    return this.post('/api/web/v1/student', payload);
  }

  getUser() {
    return this.get('/api/web/v1/student');
  }

  // Session probe: 200 with the student, or 200 with {} when nobody is signed in.
  getSession() {
    return this.get('/api/web/v1/student_sessions');
  }

  setUser(payload) {
    return this.put('/api/web/v1/student', { student: payload });
  }

  signUpTheoryAccessStudent = (schoolId, payload) => this.post(`/api/web/v1/schools/${schoolId}/theory_access_students`, payload);

  signUpTheoryAccessStudentWithFb = (schoolId, payload) => this.post(`/api/web/v1/schools/${schoolId}/theory_access_students/create_facebook`, payload);

  getProUser = () => this.get('/api/web/v1/pro/users/me');

  createCandidateLibre = (payload) => this.post('/api/web/v1/candidates', payload);
}

export default new UserAPI();
